module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/secret-key-img-f2c4299375cea799.png"+" 482w",
        images: [{path: __webpack_public_path__ + "assets/images/secret-key-img-f2c4299375cea799.png",width: 482,height: 512}],
        src: __webpack_public_path__ + "assets/images/secret-key-img-f2c4299375cea799.png",
        toString: function(){return __webpack_public_path__ + "assets/images/secret-key-img-f2c4299375cea799.png"},
        
        width: 482,
        height: 512
      }